export default "__VITE_ASSET__rtumYKnN__"